module.exports = __webpack_public_path__ + "img/animated-skills-bar.a801cea3.jpg";